import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'cotaEnergiaNuclear'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/perfis/${id}/cotas_energia_nuclear`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/cotas_energia_nuclear/${id}`

    case 'import':
      return '/acl/cotas_energia_nuclear/import'

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingCotaEnergiaNuclearSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingCotaEnergiaNuclearSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_COTA_ENERGIA_NUCLEAR_SUCCESS = 'LOADING_COTA_ENERGIA_NUCLEAR_SUCCESS'
export function loadingCotaEnergiaNuclearSuccess(cotaEnergiaNuclear) {
  return {
    type: LOADING_COTA_ENERGIA_NUCLEAR_SUCCESS,
    cotaEnergiaNuclear,
  }
}

export const DESTROYING_COTA_ENERGIA_NUCLEAR_SUCCESS = 'DESTROYING_COTA_ENERGIA_NUCLEAR_SUCCESS'
export function destroyingCotaEnergiaNuclearSuccess(cotaEnergiaNuclearId) {
  return {
    type: DESTROYING_COTA_ENERGIA_NUCLEAR_SUCCESS,
    cotaEnergiaNuclearId,
  }
}

export function fetchMultipleCotaEnergiaNuclear(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchCotaEnergiaNuclear(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createCotaEnergiaNuclear(parentId, cotaEnergiaNuclear) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      cotaEnergiaNuclear
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function importEnergiaNuclear(multipleEnergiaNuclear) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint('import'), 'POST', multipleEnergiaNuclear).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateCotaEnergiaNuclear(id, cotaEnergiaNuclear) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', cotaEnergiaNuclear).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyCotaEnergiaNuclear(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const cotaEnergiaNuclear = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_COTA_ENERGIA_NUCLEAR_SUCCESS: {
      const { cotaEnergiaNuclear: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_COTA_ENERGIA_NUCLEAR_SUCCESS:
      return state.delete(action.cotaEnergiaNuclearId.toString())

    default:
      return state
  }
}

export default cotaEnergiaNuclear
